import requests , { setToken } from "../../services/httpServices";
import {showErrorAlert} from "./AlertService";


const TeacherServices = {

  getVideosWithQuiz: async (teacherId) => {
    try {
        const token = localStorage.getItem("token");
        setToken(token);
      const response = await requests.get(`/quiz/get-videos-with-quiz${teacherId ? `?teacherId=${teacherId}` : ''}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
    });
   
      return response;
   
     
    } catch (error) {
    
      showErrorAlert(error); 
  
    
      throw error;
    }
  },

  getAllTeachers: async (params) => {
    try {
        const token = localStorage.getItem("token");
        setToken(token);
      const response = await requests.get('school/get-all-school-teachers', { params });
      return response;
    } catch (error) {
      showErrorAlert(error); 
      throw error;
    }
  },

  getdashboardTeachers: async () => {
    try {
        const token = localStorage.getItem("token");
        setToken(token);
      const response = await requests.get('school/school-dashboard');
      return response;
    } catch (error) {
      showErrorAlert(error); 
      throw error;
    }
  },

  schooledit: async (userdetials) => {
    try{
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.put('/school/schooledit', userdetials);
      return response;
    } catch(error){
      console.log(error,"errorr");
      showErrorAlert(error);  
    }
  },

  getSchool: async (school_id) => {
    try {
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.get(`/school/${school_id}`);
      return response;
    } catch (error) {
      showErrorAlert(error);  
    }
  },

  addSchoolTeacher: async (name, email) => {
    try {
        const token = localStorage.getItem("token");
        setToken(token);
        const response = await requests.post('/school/add-school-teacher', { name, email }); // ✅ Fixed
        return response;
    } catch (error) {
      showErrorAlert(error); 
        throw error;
    }
  },

  getCertificateTitles: async () => {
    try {
        const token = localStorage.getItem("token");
        setToken(token);
        const response = await requests.get('/certificates/get-all-certificate-list'); // ✅ Fixed
        return response;
    } catch (error) {
      showErrorAlert(error); 
        throw error;
    }
  },
  getCertificatesByTeacher: async (teacher_id) => {
    try {
      console.log('Fetching certificates for teacher_id:', teacher_id);
      
      // ✅ Corrected URL using route parameter
      const response = await requests.get(`/auth/all-certificate/${teacher_id}`);

      console.log('API response:', response); // Log only response.data
      return response; // ✅ Return `response.data`, not full response object
    } catch (error) {
      showErrorAlert(error); 
      throw error;
    }
  },

  getTeacher: async (teacher_id) => {
    try {
        const token = localStorage.getItem("token");
        setToken(token);
        const response = await requests.get(`/school/getTeacher/${teacher_id}`);
        return response;
    } catch (error) {
      showErrorAlert(error); 
        throw error;
    }
  },

  updateTeacher: async (teacherData) => {
    try{
      const token = localStorage.getItem("token");
      setToken(token);
      const response = await requests.put(`/school/updateTeacher`, teacherData); 
      return response;
    } catch (error) {
      showErrorAlert(error);
    }
  },

  deleteTeacher: async (teacherId) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);

      const response = await requests.delete(
        `/admin/delete-teacher/${teacherId}`
      );

      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  
};
  
export default TeacherServices;